import { useAxios } from '@/shared/composables/axios'
import { isElectron, tauriMode } from '@/shared/utils/import-meta'


const RELOAD_HEADER = 'x-force-reload'
const RELOAD_COOLDOWN_MS = 120_000
const STORAGE_KEY = 'forceReloadLast'

/**
 * Подключает проверку заголовка X-Force-Reload в ответах API.
 * При значении 1 — перезагрузка страницы (команда с сервера для обновления веб-клиентов).
 * Только веб; в Electron/Tauri не используется. Отдельный эндпоинт не нужен — проверяются ответы любого API.
 * Cooldown 2 мин, чтобы не перезагружать повторно подряд.
 */
export const useForceReloadSignal = (): void => {
  if (isElectron() || tauriMode()) return

  const { axiosInstance } = useAxios()

  axiosInstance.interceptors.response.use((response) => {
    if (response.headers[RELOAD_HEADER] !== '1') return response
    if (document.visibilityState !== 'visible') return response

    const last = sessionStorage.getItem(STORAGE_KEY)
    const now = Date.now()
    if (last && now - Number(last) < RELOAD_COOLDOWN_MS) return response

    sessionStorage.setItem(STORAGE_KEY, String(now))
    window.location.reload()
    return response
  })
}
